import styled from 'styled-components';

const PageWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  background-color: ${({ theme }) => theme.colors.mainColorContrast};
`;

const ContentHeaderWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.mainColorContrast};
  padding-right: 32px;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 48px 32px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: ${({ theme }) => theme.colors.backgroundColorWhite};
`;

export {
  PageWrapper,
  ContentHeaderWrapper,
  ContentWrapper,
};
